"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var assert_1 = __importDefault(require("assert"));
var shared_1 = __importDefault(require("./shared"));
var BufferReader = /** @class */ (function () {
    function BufferReader(buffer) {
        assert_1.default(Buffer.isBuffer(buffer), 'Invalid buffer.');
        this.buffer = buffer;
        this.position = 0;
    }
    /**
     *
     * @param offset The offset to seek.
     * @param origin The seek origin. True means seeking from begining. False means seeking from current position. Default is True.
     */
    BufferReader.prototype.seek = function (offset, origin) {
        if (origin === void 0) { origin = true; }
        this.position = shared_1.default(offset, this.position, this.buffer.length, origin);
    };
    BufferReader.prototype.nextDouble = function () {
        return this.nextDoubleLE();
    };
    BufferReader.prototype.nextDoubleLE = function () {
        return this._nextXX('DoubleLE', 8);
    };
    BufferReader.prototype.nextDoubleBE = function () {
        return this._nextXX('DoubleBE', 8);
    };
    BufferReader.prototype.nextFloat = function () {
        return this.nextFloatLE();
    };
    BufferReader.prototype.nextFloatLE = function () {
        return this._nextXX('FloatLE', 4);
    };
    BufferReader.prototype.nextFloatBE = function () {
        return this._nextXX('FloatBE', 4);
    };
    BufferReader.prototype.nextInt32 = function () {
        return this.nextInt32LE();
    };
    BufferReader.prototype.nextInt32LE = function () {
        return this._nextXX('Int32LE', 4);
    };
    BufferReader.prototype.nextInt32BE = function () {
        return this._nextXX('Int32BE', 4);
    };
    BufferReader.prototype.nextUInt32 = function () {
        return this.nextUInt32LE();
    };
    BufferReader.prototype.nextUInt32LE = function () {
        return this._nextXX('UInt32LE', 4);
    };
    BufferReader.prototype.nextUInt32BE = function () {
        return this._nextXX('UInt32BE', 4);
    };
    BufferReader.prototype.nextUInt16 = function () {
        return this.nextUInt16LE();
    };
    BufferReader.prototype.nextUInt16LE = function () {
        return this._nextXX('UInt16LE', 2);
    };
    BufferReader.prototype.nextUInt16BE = function () {
        return this._nextXX('UInt16BE', 2);
    };
    BufferReader.prototype.nextInt16 = function () {
        return this.nextInt16LE();
    };
    BufferReader.prototype.nextInt16LE = function () {
        return this._nextXX('Int16LE', 2);
    };
    BufferReader.prototype.nextInt16BE = function () {
        return this._nextXX('Int16BE', 2);
    };
    BufferReader.prototype.nextUInt8 = function () {
        return this._nextXX('UInt8', 1);
    };
    BufferReader.prototype.nextInt8 = function () {
        return this._nextXX('Int8', 1);
    };
    BufferReader.prototype.nextBuffer = function (length) {
        this._checkPositive(length);
        this._checkOffsetInRange(this.position + length);
        var buffer = this.buffer.slice(this.position, this.position + length);
        this.position += length;
        return buffer;
    };
    BufferReader.prototype.nextString = function (length, encoding) {
        if (encoding === void 0) { encoding = 'utf-8'; }
        this._checkPositive(length);
        this._checkOffsetInRange(this.position + length);
        var str = this.buffer.toString(encoding, this.position, this.position + length);
        this.position += length;
        return str;
    };
    BufferReader.prototype._nextXX = function (type, size) {
        this._checkOffsetInRange(this.position + size);
        var methodName = "read" + type;
        var v = this.buffer[methodName](this.position);
        this.position += size;
        return v;
    };
    BufferReader.prototype._checkPositive = function (number, name) {
        if (name === void 0) { name = 'Length'; }
        assert_1.default(number >= 0, name + " must be positive.");
    };
    BufferReader.prototype._checkOffsetInRange = function (offset) {
        assert_1.default(offset >= 0 && offset <= this.buffer.length, 'Offset out of range.');
    };
    return BufferReader;
}());
exports.default = BufferReader;
